import pub from './../public';
const type = pub.getLang();

const language = {
 'zh-hk': {
  subscribe:'樓盤訂閱',
  tutorial: '功能教學',
  setNow: '立即設定',
  setEmailNotice: '刊登樓盤前，必須設定電郵',
  ok: '知道了',
  coin100: '個金幣',
  welcome1: '歡迎你使用House730',
  welcome2: '個金幣已經存入你的賬戶，供閣下作放盤之用',
  coin: '持有House730金幣數量',
  memberCenter: '會員中心',
  refresh: '更新',
  numberProperties: '現有放盤 ',
  balance: '現有屋幣',
  postProperty: '刊登樓盤',
  editProperty: '管理我的樓盤',
  manageMessages: '管理樓盤問答',
  myFavourites: '樓盤收藏',
  browseHistory: '瀏覽記錄',
  postFurniture: '刊登二手物品',
  editFurniture: '更改我的二手物品',
  manageFurniture: '管理二手傢俬問答',
  propertyListings: '刊登樓盤價格',
  // hseMoneyTopUp: '儲值金幣',
  hseMoneyTopUp: '購買House730金幣',
  purchaseHistory: '訂單管理',
  logOut: '會員登出',
  search: '搵樓',
  rentSearch: '揾租盤',
  tools: {
   buy: {
    title: '我要買樓',
    residential: '住宅',
    offices: '工商舖',
    newHomes: '新盤',
    mapSearch: '地圖搵樓',
    soldPrices: '樓市成交',
    mortgageCal: '按揭計算',
    myFavourites: '樓盤收藏',
    vr: 'VR睇樓',
    new: '一手新盤',
   },
   rent: {
    title: '我要租樓',
    residential: '住宅',
    offices: '工商舖',
    mapSearch: '地圖搵樓',
    myFavourites: '樓盤收藏'
   },
   landlord: {
    title: '我是業主',
    listingFees: '刊登費用',
    postProperty: '刊登放盤',
    memberCentre: '會員中心',
    myListings: '管理樓盤'
   },
   tools: {
    data: '最新成交',
    title: '常用工具',
    news: '地產新聞',
    mortgageCal: '按揭計算',
    contactUs: '聯絡我們',
    propertyTips: '置業百科',
    facebook: 'House730 facebook'
   }
  }
 },
 'zh-cn': {
  subscribe:'楼盘订阅',
  tutorial: '功能教学',
  setNow: '立即设定',
  setEmailNotice: '刊登楼盘前，必须设定电邮',
  ok: '知道了',
  coin100: '个金币',
  welcome1: '欢迎你使用house730',
  welcome2: '个金币已经存入你的账户，供阁下做放盘之用',
  coin: '持有House730金币数量',
  memberCenter: '会员中心',
  refresh: '更新',
  numberProperties: '现有放盘 ',
  balance: '现有屋币',
  postProperty: '刊登楼盘',
  editProperty: '管理我的楼盘',
  manageMessages: '管理楼盘问答',
  myFavourites: '楼盘收藏',
  browseHistory: '浏览记录',
  postFurniture: '刊登二手物品',
  editFurniture: '更改我的二手物品',
  manageFurniture: '管理二手傢俬问答',
  propertyListings: '刊登楼盘价格',
  // hseMoneyTopUp: '储值金币',
  hseMoneyTopUp: '购买House730金币',
  purchaseHistory: '订单管理',
  logOut: '会员登出',
  search: '揾楼',
  rentSearch: '揾租盘',
  tools: {
   buy: {
    title: '我要买楼',
    residential: '住宅',
    offices: '工商铺',
    newHomes: '新盘',
    mapSearch: '地图搵楼',
    soldPrices: '楼市成交',
    mortgageCal: '按揭计算',
    myFavourites: '楼盘收藏',
    vr: 'VR睇楼',
    new: '一手新盘',
   },
   rent: {
    title: '我要租楼',
    residential: '住宅',
    offices: '工商铺',
    mapSearch: '地图搵楼',
    myFavourites: '楼盘收藏'
   },
   landlord: {
    title: '我是业主',
    listingFees: '刊登费用',
    postProperty: '刊登放盘',
    memberCentre: '会员中心',
    myListings: '管理楼盘'
   },
   tools: {
    data: '最新成交',
    title: '常用工具',
    news: '地产新闻',
    mortgageCal: '按揭计算',
    contactUs: '联络我们',
    propertyTips: '置业百科',
    facebook: 'House730 facebook'
   }
  }
 },
 'en-us': {
  subscribe:'Property Subscription',
  tutorial: 'Tutorial',
  setNow: 'Edit ',
  setEmailNotice: 'You must add your email before listing a property',
  ok: 'OK',
  coin100: 'Gold Coins',
  welcome1: 'Welcome to House730',
  welcome2: 'Gold Coins has been deposited to your account for posting property use',
  coin: 'No. of House730 Gold Coin',
  memberCenter: 'Member Center',
  refresh: 'Refresh',
  numberProperties: 'Current Listing ',
  balance: 'Balance',
  postProperty: 'Property Listing',
  editProperty: 'Manage My Properties',
  manageMessages: 'Manage Messages',
  myFavourites: 'My Bookmark',
  browseHistory: 'Browsing History',
  postFurniture: 'Post Secondhand Furniture',
  editFurniture: 'Edit Furniture',
  manageFurniture: 'Manage Furniture Messages',
  propertyListings: 'Property Listing Fee',
  // hseMoneyTopUp: 'HseMoney Top-Up',
  // hseMoneyTopUp: 'Buy House730 Gold Coin',
  // purchaseHistory: 'Purchase History',
  // logOut: 'Log out',
  hseMoneyTopUp: 'Buy House730 Gold Coin',
  purchaseHistory: 'Orders',
  logOut: 'Logout',
  search: 'Search',
  rentSearch: 'Search',
  tools: {
   buy: {

    title: 'Buy',
    residential: 'Residential',
    offices: 'Commercial',
    newHomes: 'New Property',
    mapSearch: 'Map Search  ',
    soldPrices: 'Property Transaction',
    mortgageCal: 'Mortgage Calculation',
    myFavourites: 'Bookmark Property',
    vr: 'VR',
    new: 'New Property',
   },
   rent: {
    title: 'Rent',
    residential: 'Residential',
    offices: 'Commercial',
    mapSearch: 'Map Search',
    myFavourites: 'Bookmark Property'
   },
   landlord: {
    title: 'Landlord',
    listingFees: 'Listing Fee',
    postProperty: 'Property Listing',
    memberCentre: 'Member Centre',
    myListings: 'My Property Listing'
   },
   tools: {
    data: 'Latest Trans',
    title: 'Tools',
    news: 'News',
    mortgageCal: 'Mortgage Cal',
    contactUs: 'Contact Us',
    propertyTips: '置業百科',
    facebook: 'House730 facebook'
   }
  }
 }
};
export default language[type];